import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';
import { isLeadFormKeyExist } from '../lib/gatewayFormHelper';

export default class ArticleFootNotecontainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const articleFooterContentLinks =
      document.getElementById('foot-note') &&
      document.getElementById('foot-note').getElementsByTagName('a');
    if (articleFooterContentLinks) {
      let currentIndex = 0;
      while (currentIndex < articleFooterContentLinks.length) {
        articleFooterContentLinks[currentIndex].setAttribute(
          'data-pa-click',
          JSON.stringify({ 
            link: `articleFooterContent-link-${this.props.articleInfo.metadata.documentId}-${articleFooterContentLinks[currentIndex].innerText}`, 
            event_name: 'brc_articleFooterContent_clicked' 
          }),
        );
        currentIndex++;
      }
    }
  }
  render() {
    const { content } = this.props.articleInfo;
    const legalContent = content.footer;
    const innerHtml = getHTMLElement(legalContent, { useHTML: true });
    const {
      isPardotTrueExist,
      leadFormKey,
      isSlugIdExist,
      leadCapturePatdotUrl,
      isECMLive,
    } = this.props;

    const hideContentStyle = { display: 'none' };
    const showContentStyle = { display: '' };

    const displayContent =
      isECMLive === 'true'
        ? isSlugIdExist && leadCapturePatdotUrl !== undefined
          ? isLeadFormKeyExist(leadFormKey)
            ? isPardotTrueExist
              ? showContentStyle
              : hideContentStyle
            : showContentStyle
          : showContentStyle
        : isSlugIdExist
        ? isLeadFormKeyExist(leadFormKey)
          ? isPardotTrueExist
            ? showContentStyle
            : hideContentStyle
          : showContentStyle
        : showContentStyle;
    return (
      <div id="foot-note" className="foot-note" style={displayContent}>
        <section>{innerHtml}</section>
      </div>
    );
  }
}

ArticleFootNotecontainer.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      footer: PropTypes.string,
    }),
  }),
};
